import { createSelector } from '@reduxjs/toolkit';

const memoizedNotifications = createSelector(
  (state) => state.notifications,
  (notifications) => {
    const notificationList = Object.values(notifications);

    return notificationList;
  },
);

const selectNotifications = () => memoizedNotifications;

export const notificationSelectors = {
  selectNotifications,
};
